import React, { useState } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import config from '../config/config';

const AddStudyAbroadPage = () => {
  const navigate = useNavigate()

  const [formData, setFormData] = useState({
    pageName: '',
    bannnerHeading: '',
    bannnerSubHeading1: '',
    bannnerSubHeading2: '',
    tableHeading: '',
    tableSubHeading: '',
    tablelist: [],
    cardlist: [],
  });

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const handleTableListChange = (index, e) => {
    const { name, value, files } = e.target;
    const updatedTableList = [...formData.tablelist];
    if (files) {
      updatedTableList[index][name] = files[0];
    } else {
      updatedTableList[index][name] = value;
    }
    setFormData(prev => ({ ...prev, tablelist: updatedTableList }));
  };

  const handleCardListChange = (index, e) => {
    const { name, value, files } = e.target;
    const updatedCardList = [...formData.cardlist];
    if (files) {
      updatedCardList[index][name] = files[0];
    } else {
      updatedCardList[index][name] = value;
    }
    setFormData(prev => ({ ...prev, cardlist: updatedCardList }));
  };

  const addTableRow = () => {
    setFormData(prev => ({
      ...prev,
      tablelist: [...prev.tablelist, { image: '', collageName: '', fees: '', dicountFee: '' }]
    }));
  };

  const removeTableRow = (index) => {
    const updatedTableList = [...formData.tablelist];
    updatedTableList.splice(index, 1);
    setFormData(prev => ({ ...prev, tablelist: updatedTableList }));
  };

  const addCardRow = () => {
    setFormData(prev => ({
      ...prev,
      cardlist: [...prev.cardlist, { image: '', text: '' }]
    }));
  };

  const removeCardRow = (index) => {
    const updatedCardList = [...formData.cardlist];
    updatedCardList.splice(index, 1);
    setFormData(prev => ({ ...prev, cardlist: updatedCardList }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const data = new FormData();
    data.append('pageName', formData.pageName);
    data.append('bannnerHeading', formData.bannnerHeading);
    data.append('bannnerSubHeading1', formData.bannnerSubHeading1);
    data.append('bannnerSubHeading2', formData.bannnerSubHeading2);
    data.append('tableHeading', formData.tableHeading);
    data.append('tableSubHeading', formData.tableSubHeading);

    formData.tablelist.forEach((item, index) => {
      data.append(`tablelist[${index}][image]`, item.image);
      data.append(`tablelist[${index}][collageName]`, item.collageName);
      data.append(`tablelist[${index}][fees]`, item.fees);
      data.append(`tablelist[${index}][dicountFee]`, item.dicountFee);
    });

    formData.cardlist.forEach((item, index) => {
      data.append(`cardlist[${index}][image]`, item.image);
      data.append(`cardlist[${index}][text]`, item.text);
    });

    try {
      const response = await axios.post(`${config.API_BASE_URL}/api/admin/create_studyaborad`, data);
      console.log('Success:', response.data);
      alert('Data saved successfully!');
    } catch (error) {
      console.error('Error:', error);
      alert('Something went wrong!');
    }
  };

  return (
    <div className="container mt-5 pt-5">
      <div className="row">
        <div className="col-lg-2"></div>
        <div className="col-lg-10">
          <h1>Add Study Abroad Page</h1>
          <form onSubmit={handleSubmit} encType="multipart/form-data">
            {/* Banner Section */}
            <div className="mb-3">
              <label>Page Name</label>
              <input type="text" className="form-control" name="pageName" value={formData.pageName} onChange={handleInputChange} required />
            </div>
            <div className="mb-3">
              <label>Banner Heading</label>
              <input type="text" className="form-control" name="bannnerHeading" value={formData.bannnerHeading} onChange={handleInputChange} required />
            </div>
            <div className="mb-3">
              <label>Banner Sub Heading 1</label>
              <input type="text" className="form-control" name="bannnerSubHeading1" value={formData.bannnerSubHeading1} onChange={handleInputChange} required />
            </div>
            <div className="mb-3">
              <label>Banner Sub Heading 2</label>
              <input type="text" className="form-control" name="bannnerSubHeading2" value={formData.bannnerSubHeading2} onChange={handleInputChange} required />
            </div>

            {/* Table Section */}
            <div className="mb-3">
              <label>Table Heading</label>
              <input type="text" className="form-control" name="tableHeading" value={formData.tableHeading} onChange={handleInputChange} required />
            </div>
            <div className="mb-3">
              <label>Table Sub Heading</label>
              <input type="text" className="form-control" name="tableSubHeading" value={formData.tableSubHeading} onChange={handleInputChange} required />
            </div>

            <div className="mb-3">
              <h4>Table List</h4>
              {formData.tablelist.map((item, index) => (
                <div key={index} className="border p-3 mb-3">
                  <input type="file" name="image" className="form-control mb-2" onChange={(e) => handleTableListChange(index, e)} required />
                  <input type="text" name="collageName" className="form-control mb-2" placeholder="College Name" value={item.collageName} onChange={(e) => handleTableListChange(index, e)} required />
                  <input type="text" name="fees" className="form-control mb-2" placeholder="Fees" value={item.fees} onChange={(e) => handleTableListChange(index, e)} required />
                  <input type="text" name="dicountFee" className="form-control mb-2" placeholder="Discount Fee" value={item.dicountFee} onChange={(e) => handleTableListChange(index, e)} required />
                  <button type="button" className="btn btn-danger" onClick={() => removeTableRow(index)}>Remove</button>
                </div>
              ))}
              <button type="button" className="btn btn-primary" onClick={addTableRow}>Add Table Data</button>
            </div>

            {/* Card Section */}
            <div className="mb-3">
              <h4>Card List</h4>
              {formData.cardlist.map((item, index) => (
                <div key={index} className="border p-3 mb-3">
                  <input type="file" name="image" className="form-control mb-2" onChange={(e) => handleCardListChange(index, e)} required />
                  <input type="text" name="text" className="form-control mb-2" placeholder="Text" value={item.text} onChange={(e) => handleCardListChange(index, e)} required />
                  <button type="button" className="btn btn-danger" onClick={() => removeCardRow(index)}>Remove</button>
                </div>
              ))}
              <button type="button" className="btn btn-primary" onClick={addCardRow}>Add Card Data</button>
            </div>

            <button type="submit" className="btn btn-success">Submit</button>
          </form>
        </div>
      </div>
    </div>
  );
};

export default AddStudyAbroadPage;
